export default __webpack_public_path__ + "static/media/coin-bg.b5633f1f.png";